import { ProtocoloService } from "../domain/services/protocoloService";

export class GetProtocolosInforme {
  constructor(private protocoloService: ProtocoloService) {}

  async execute(ordenDeTrabajo: number, token: string) {
    const protocoloInforme: string =
      await this.protocoloService.getProtocoloInforme(ordenDeTrabajo, token);
    return protocoloInforme;
  }
}
